export const APP_CONFIG = {
    app: {
        name: 'Paywon'
    },
    company: {
        name: 'PAYWON PRIVATE LIMITED',
        gst: '',
        pan: '',

    },
    contacts: {
        call: '+917002055429',
        whatsapp: 'https://wa.me/919876543210',
        email: 'support@rechargeapp.com',
        email: 'support@rechargeapp.com'
    },
    socialLinks: {
        facebook: '',
        instagram: '',
        youtube: ''
    },
    urls: {
        terms: 'https://paywon.in/policy.html?tab=terms',
        privacy: 'https://paywon.in/policy.html?tab=privacy',
    },
    colors: {
        bgColor: '#ffffff',
        primaryColor: '#2f31ee',
        primaryLight: '#6869f3',
        primaryDark: '#2527bd',
        textPrimary: '#11132f',
        textSecondary: '#6b7280',
        textOnPrimary: '#ffffff',
        borderColor: '#e1e2f5',
        surfaceColor: '#f5f5ff',
        errorColor: '#ef4444',
        borderRadius: 14,
    }
};